import { useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { Box, Spinner, Alert, AlertIcon, Container } from "@chakra-ui/react";
import AboutBusinessAutomation from "../components/AboutUs/AboutBAT";
import { clientFeedbackService, formatClientFeedbackData } from "../services/clientFeedbackService";
import ScrollToTop from "../components/Common/ScrollToTop";
import { useBlogs } from "../hooks/useBlog";
import { aboutUsService, formatAboutUsData } from "../services/aboutUsService";

const AboutUs = () => {
  const [aboutUsData, setAboutUsData] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Call hooks at the top level
  useEffect(() => {
    fetchAboutUsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAboutUsData = async () => {
    try {
      setLoading(true);
      
      // Fetch about us data
      const response = await aboutUsService.getAboutUsData();
      if (response.success) {
        const formattedData = formatAboutUsData(response.data);
        setAboutUsData(formattedData);
        
        if (response.error) {
          console.warn(response.error);
        }
      } else {
        setError(response.error);
      }

      // Fetch client feedback data
      const feedbackResponse = await clientFeedbackService.getClientFeedback();
      if (feedbackResponse.success && feedbackResponse.data) {
        const formattedTestimonials = formatClientFeedbackData(feedbackResponse.data);
        setTestimonials(formattedTestimonials);
      }
    } catch (err) {
      setError('Failed to load about us data');
      console.error('Error fetching about us data:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container maxW="container.xl" py={8}>
        <Box display="flex" justifyContent="center" alignItems="center" minH="400px">
          <Spinner size="xl" color="#000B8C" thickness="4px" />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxW="container.xl" py={8}>
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Trusted eGovernment & AI Technology Partner in Bangladesh</title>
        <meta 
          name="description" 
          content="Discover Business Automation Ltd., a trusted technology partner over 25 years, delivering AI-driven eGovernment and enterprise solutions for 300+ clients in Bangladesh." 
        />
        <meta 
          name="keywords" 
          content="eGovernment solutions Bangladesh, AI-powered software Bangladesh, workflow automation Bangladesh, customer service management system Bangladesh, ITES company Bangladesh, RPA in public sector Bangladesh, smart kiosks Bangladesh, intelligent automation in government, AI and NLP citizen services Bangladesh, software outsourcing Bangladesh, trusted technology partner Bangladesh, national digital transformation Bangladesh, BASIS ICT Awards Bangladesh, women in tech Bangladesh, employee-first IT company Bangladesh, SLA-based IT support Bangladesh, eGovernment training Bangladesh" 
        />
        <link rel="canonical" href="https://www.ba-systems.com/about-us" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:url" content="https://ba-systems.com/about-us" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Trusted eGovernment & AI Technology Partner in Bangladesh" />
        <meta property="og:description" content="Discover Business Automation Ltd., a trusted technology partner over 25 years, delivering AI-driven eGovernment and enterprise solutions for 300+ clients in Bangladesh." />
        <meta property="og:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="ba-systems.com" />
        <meta property="twitter:url" content="https://ba-systems.com/about-us" />
        <meta name="twitter:title" content="Trusted eGovernment & AI Technology Partner in Bangladesh" />
        <meta name="twitter:description" content="Discover Business Automation Ltd., a trusted technology partner over 25 years, delivering AI-driven eGovernment and enterprise solutions for 300+ clients in Bangladesh." />
        <meta name="twitter:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />
      </Helmet>
      
      <Box
      minH="100vh"
      backgroundImage="url(/png/background.png)"
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      backgroundAttachment="fixed"
    >
      <AboutBusinessAutomation data={aboutUsData} />
      {/* <RecentBlogPosts 
        blogPosts={blogPosts} 
        title="Newsroom"
        loading={blogLoading}
        error={blogError}
      /> */}
      <ScrollToTop />
    </Box>
    </>
  );
};

export default AboutUs;


// partnership and colaboration blog er age